import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const notify = (message, type = "error") => {
  const options = {
    position: "top-right",
    autoClose: 2000, // Can be customized for each type if needed
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: "light",
  };

  // Trigger the correct toast based on type
  if (type === "success") {
    toast.dismiss();
    toast.success(message, options);
  } else if (type === "info") {
    toast.dismiss();
    toast.info(message, options);
  } else {
    toast.dismiss();
    toast.error(message, options);
  }
};
